// extracted by mini-css-extract-plugin
export var footer = "_n3-0";
export var inherit = "_n3-1";
export var input = "_n3-2";
export var modalContent = "_n3-3";
export var quillEditor = "_n3-4";
export var subtitle = "_n3-5";